let requestCounter = 0;

export const nextRequestId = (childKey: string): string => {
  requestCounter += 1;
  return `${childKey}#${requestCounter}`;
};
